import { render, staticRenderFns } from "./ScheduleRecordTable.vue?vue&type=template&id=3d5828ce&scoped=true&"
import script from "./ScheduleRecordTable.vue?vue&type=script&lang=js&"
export * from "./ScheduleRecordTable.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleRecordTable.vue?vue&type=style&index=0&id=3d5828ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5828ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VDataTable,VImg})
